import React, { useState } from 'react';

import Send from 'Icons/Send';
import Button, { ButtonProps } from 'components/AntD/Button';
import slColors from 'sl-colors';
import CandidateSharePageNewInviteModal from 'components/CandidateComponents/CandidateSharePageNewInviteWrapper';

const SendSearchlightReportButton = ({ ...props }: ButtonProps) => {
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);

  return (
    <>
      {isSendModalOpen && (
        <CandidateSharePageNewInviteModal
          isVisible={isSendModalOpen}
          setIsVisible={setIsSendModalOpen}
        />
      )}
      <Button
        variant="contained"
        className="tw-bg-primary-100 tw-border tw-border-primary tw-text-gray-900 tw-font-semibold tw-py-3 tw-px-4 tw-h-fit"
        onClick={() => setIsSendModalOpen(true)}
        {...props}
      >
        <div className="tw-flex tw-flex-row tw-justify-start tw-gap-4 tw-w-full tw-items-center">
          <Send width={22} height={22} color={slColors.primary[700]} />
          Send Searchlight report
        </div>
      </Button>
    </>
  );
};

export default SendSearchlightReportButton;
